export default "__VITE_ASSET__CI4z8JU5__"